import * as React from 'react';
import { useParams } from 'react-router-dom';
import { PublicChatView } from '../components/PublicChatView';
import type { Echo } from '@/types';
import echoCreatedImage from '@/assets/images/webp/echo_created.webp';

/**
 * PublicChatPage
 *
 * Route: /:echoName
 * Renders the public chat interface for a specific Echo.
 */
export const PublicChatPage: React.FC = () => {
  const { echoName } = useParams<{ echoName: string }>();
  const displayName = echoName ? decodeURIComponent(echoName) : 'Unknown Echo';

  // Construct a temporary Echo object for the UI
  const mockEcho: Echo = {
    id: 'public-echo-id',
    name: displayName,
    category: 'Public Figure',
    domain: 'General',
    imageUrl: echoCreatedImage, // Fallback image
  };

  return (
    <div className='h-dvh w-full overflow-hidden bg-black'>
      <PublicChatView echo={mockEcho} echoName={displayName} />
    </div>
  );
};

export default PublicChatPage;
